<template>
  <div class="wrong-page-popup-overlay" v-if="show">
    <div class="wrong-page-popup">
      <div class="popup-content">
        <p class="popup-message">
          請先前往「<strong>{{ pageName }}</strong>」完成教學！
        </p>
        <button class="popup-btn" @click="handleRedirect">
          前往{{ pageName }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TutorialWrongPagePopup',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String,
      default: ''
    },
    targetComponent: {
      type: String,
      default: ''
    }
  },

  emits: ['redirect', 'change-judge'],

  methods: {
    handleRedirect() {
      // Emit change-judge to navigate to correct page
      if (this.targetComponent) {
        this.$emit('change-judge', this.targetComponent);
      }
      this.$emit('redirect');
    }
  }
};
</script>

<style lang="scss" scoped>
.wrong-page-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100010;
}

.wrong-page-popup {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px 32px;
  max-width: 320px;
  width: 90%;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  animation: popupFadeIn 0.3s ease;
}

@keyframes popupFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.popup-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.popup-message {
  font-size: 16px;
  color: #333333;
  line-height: 1.5;
  margin: 0;

  strong {
    color: #4a90d9;
  }
}

.popup-btn {
  background: #4a90d9;
  border: none;
  color: #ffffff;
  padding: 12px 24px;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #357abd;
  }

  &:active {
    transform: scale(0.98);
  }
}
</style>
